


















import {SvgSymbolData} from '@/icons';
import SvgIcon from '@/icons/SvgIcon.vue';
import { fromPairs } from 'lodash-es';
import {v4 as uuid} from 'uuid';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ChoiceOption, StringArray} from './values';

type Value = ChoiceOption | ChoiceOption[] | null;
interface SelectableOption {
    option: ChoiceOption;
    selected: boolean;
}

@Component({
    components: {SvgIcon},
})
export default class ChoiceControl extends Vue {
    @Prop({type: Boolean, default: false})
    public readonly multiChoice: boolean;

    @Prop({type: Array, required: true})
    public readonly options: ChoiceOption[];

    @Prop({required: true})
    public readonly value: Value;

    @Prop({type: Object, required: true})
    public readonly icons: {[iconId: string]: SvgSymbolData};

    protected get optionValues(): StringArray {
        return fromPairs(this.options.map((option) => [option.value, uuid()]));
    }

    protected checkedChange(option: ChoiceOption, checked: boolean): void {
        if (checked) {
            this.$emit(
                'input',
                this.multiChoice
                    ? [...this.selectedValues, option]
                    : option,
            );
        } else {
            this.$emit(
                'input',
                this.multiChoice
                    ? this.selectedValues.filter(x => x.value !== option.value)
                    : null,
            );
        }
    }

    private get selectableOptions(): SelectableOption[] {
        const selectedValues = this.selectedValues;

        return this.options.map(option => ({
            option,
            selected: selectedValues.some(selectedOption => selectedOption.value === option.value),
        }));
    }

    private get selectedValues(): ChoiceOption[] {
        const value = this.value;

        if (value === null) {
            return [];
        } else if (Array.isArray(value)) {
            return value;
        } else {
            return [value];
        }
    }
}
